import { Outlet } from 'react-router-dom';

/**
 * Root layout — wraps the entire app.
 * Theme toggle is on each layout’s header (and landing/auth).
 */
export function RootLayout() {
    return (
        <div className="min-h-screen bg-background text-foreground">
            <Outlet />
        </div>
    );
}

export default RootLayout;
